// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__-F7MO"};